import * as React from 'react';

import { ServiceAds } from '../service_ads/service_ads';
import { formatMapURL } from '../../helpers/map_helper';

const s = require('./service_block_top.css');

interface IProps {
  coordinates?: {
    lat: number;
    lng: number;
  };
  section: string;
  onAdsClick(eventLabel: string): void;
  onPremClick(eventLabel: string): void;
}

export class ServiceBlockTop extends React.Component<IProps> {
  public render() {
    return (
      <div className={`${s['c-services-top']}`}>
        <div className="cg-container-fluid-xs">
          <div className="cg-row">
            <ServiceAds
              class={`${s['c-selfads-item-premium']} cg-col-8`}
              onClick={() => this.props.onPremClick('from_main_page_buy_premium')}
              title="Ускоряйте сделки"
              description="Премиум-размещение увеличивает количество звонков в 3 раза"
              isPremiumButton
              buttonText="Купить премиум"
              buttonUrl="/promo/adv/#how-to"
            />
            <ServiceAds
              class={`${s['c-selfads-item-add']} cg-col-8`}
              onClick={() => this.props.onAdsClick('add_adv')}
              title="Размещайте объявления"
              description="Новая форма подачи позволит быстро и удобно разместить объявление"
              buttonText="Добавить объявление"
              buttonUrl="/realty/add1.aspx"
            />
            <ServiceAds
              class={`${s['c-selfads-item-map']} cg-col-8`}
              onClick={() => this.props.onAdsClick('search_on_map')}
              title="Ищите на карте"
              description="Ищите объявления рядом с работой, парком или родственниками"
              buttonText="Найти на карте"
              buttonUrl={formatMapURL(this.props.coordinates, this.props.section)}
              isNewTab
            />
          </div>
        </div>
      </div>
    );
  }
}
